import React from 'react';
import {useTranslation} from 'react-i18next';
import {CloseIcon, HelpTip, Horizontal, InfoIcon, Vertical} from '@taopix/taopix-design-system';
import {UserInterfaceActions} from '../Context/UserInterface/UserInterfaceActionTypes';
import {useUiState} from '../Context/UserInterface/UserInterfaceContext';
import {title} from 'process';

type InsideCoverNotEditableTipProps = {
  open: boolean;
  title: string;
  message: string;
};

const InsideCoverNotEditableTip = ({open, title, message}: InsideCoverNotEditableTipProps) => {
  const {t} = useTranslation();
  const ui = useUiState();

  const closeDialog = () => {
    ui.dispatch(
      UserInterfaceActions.setInsideCoverNotEditableTip({
        open: false,
        title: ui.state.insideCoverNotEditableTip.title,
        message: ui.state.insideCoverNotEditableTip.message,
      })
    );
  };

  return (
    <HelpTip
      id={'insideCoverNotEditableTip'}
      open={open}
      title={title}
      message={message}
      anchorId={'viewerToolbar'}
      anchorOrigin={
        ui.state.isSmallScreen
          ? {vertical: Vertical.Bottom, horizontal: Horizontal.Centre}
          : {vertical: Vertical.Bottom, horizontal: Horizontal.Left}
      }
      transformOrigin={
        ui.state.isSmallScreen
          ? {vertical: Vertical.Top, horizontal: Horizontal.Centre}
          : {vertical: Vertical.Top, horizontal: Horizontal.Left}
      }
      offset={ui.state.isSmallScreen ? undefined : {x: 10, y: 0}}
      className={'max-w-[min(400rem,theme(width.bounds))]'}
      buttonFunction={closeDialog}
      icon={<InfoIcon />}
      buttonProps={{startIcon: <CloseIcon />, hideLabel: true}}
      repositionOnResize
    />
  );
};

export default InsideCoverNotEditableTip;
